// extracted by mini-css-extract-plugin
export default {"globalFonts":"fonts_globalFonts__wQoCI","mobileonly":"fonts_mobileonly__zIhqA","desktoponly":"fonts_desktoponly__AKFP-"};